<template>
    <div class="second">
        <el-form ref="formData" :model="formData" label-width="130px">
            <div class="title">二、术后情况交接</div>
            <el-form-item label="1.手术名称：">
                <el-input :disabled="secondDisabled" v-model.trim="formData.operationNamePostoperative" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input>
                <span>返回留观室日时</span>
                <el-input :disabled="secondDisabled" v-model.trim="formData.observationRoomTime" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="2.麻醉方式：">
                <el-checkbox-group :disabled="secondDisabled" v-model="formData.anesthesiaMode">
                    <el-checkbox label="1">全麻</el-checkbox>
                    <el-checkbox label="2">硬麻</el-checkbox>
                    <el-checkbox label="3">局麻</el-checkbox>
                    <el-checkbox label="4">其他</el-checkbox>
                </el-checkbox-group>
                <el-input :disabled="secondDisabled" v-model.trim="formData.anesthesiaModeOther" style="width:60%;" placeholder="请输入其他"></el-input>
            </el-form-item>
            <el-form-item label="3.术中用药：">
                <span>
                    <span>输液</span>
                    <el-input :disabled="secondDisabled" v-model.trim="formData.medicationPostoperative.infusion" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input>
                    <span>ml</span>
                </span>
                <span>
                    <span>输血</span>
                    <el-input :disabled="secondDisabled" v-model.trim="formData.medicationPostoperative.transfusion" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input>
                    <span>ml</span>
                </span>
                <span>
                    <span>带回输液</span>
                    <el-input :disabled="secondDisabled" v-model.trim="formData.medicationPostoperative.returnInfusion" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input>
                    <span>ml</span>
                </span>
            </el-form-item>
            <el-form-item label="4.意识状态：">
                <el-checkbox-group :disabled="secondDisabled" v-model="formData.awarenessState">
                    <el-checkbox label="1">清醒</el-checkbox>
                    <el-checkbox label="2">模糊</el-checkbox>
                    <el-checkbox label="3">意识不清</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="5.生命体征：">
                <span class="people">
                    <span>时间:</span>
                    <el-time-picker :disabled="secondDisabled" @input="testSX" style="width:150px;margin:0 5px;" format="HH:mm" value-format="HH:mm" v-model="formData.vitalSignsPostoperative.time" placeholder="请选择时间点"></el-time-picker>
                    <!-- <el-input v-model.trim="formData.vitalSignsPostoperative.time" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input> -->
                </span>
                <span class="people">
                    <span>BP</span>
                    <el-input :disabled="secondDisabled" v-model.trim="formData.vitalSignsPostoperative.bloodPressure" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>mmHg</span>
                </span>
                <span class="people">
                    <span>T</span>
                    <el-input :disabled="secondDisabled" v-model.trim="formData.vitalSignsPostoperative.centigrade " style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>℃</span>
                </span>
                <span class="people">
                    <span>P</span>
                    <el-input :disabled="secondDisabled" v-model.trim="formData.vitalSignsPostoperative.pulse" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>次/分</span>
                </span>
                <span class="people">
                    <span>R</span>
                    <el-input :disabled="secondDisabled" v-model.trim="formData.vitalSignsPostoperative.breathe" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>次/分</span>
                </span>
            </el-form-item>
            <el-form-item label="6.术后卧位：">
                <el-checkbox-group :disabled="secondDisabled" v-model="formData.decubitusPosition">
                    <el-checkbox label="1">去枕平卧位</el-checkbox>
                    <el-checkbox label="2">平卧位</el-checkbox>
                    <el-checkbox label="3">半卧位</el-checkbox>
                    <el-checkbox label="4">其他</el-checkbox>
                </el-checkbox-group>
                <el-input :disabled="secondDisabled" v-model.trim="formData.decubitusPositionOther" style="width:60%;" placeholder="请输入其他"></el-input>

            </el-form-item>
            <el-form-item label="7.置管情况：">
                <el-checkbox-group :disabled="secondDisabled" v-model="formData.tubes">
                    <div>
                        <el-checkbox :disabled="secondDisabled" label="1">导尿管</el-checkbox>
                        <el-input :disabled="secondDisabled" v-model.trim="formData.placement[0].data" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>ml</span>
                        <el-input :disabled="secondDisabled" v-model.trim="formData.placement[0].colour" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>色</span>
                    </div>
                    <div>
                        <el-checkbox :disabled="secondDisabled" label="2">吸氧管</el-checkbox>
                        <el-input :disabled="secondDisabled" v-model.trim="formData.placement[1].data" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>升/分</span>
                    </div>
                    <div>
                        <el-checkbox :disabled="secondDisabled" label="3">引流管</el-checkbox>
                        <el-input :disabled="secondDisabled" v-model.trim="formData.placement[2].name" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>ml</span>
                        <el-input :disabled="secondDisabled" v-model.trim="formData.placement[2].data" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>ml</span>
                        <el-input :disabled="secondDisabled" v-model.trim="formData.placement[2].colour" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>色</span>
                    </div>
                    <div>
                        <span style="margin-right:66px;"></span>
                        <el-input :disabled="secondDisabled" v-model.trim="formData.placement[3].name" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>ml</span>
                        <el-input :disabled="secondDisabled" v-model.trim="formData.placement[3].data" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>ml</span>
                        <el-input :disabled="secondDisabled" v-model.trim="formData.placement[3].colour" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>色</span>
                    </div>
                    <div>
                        <el-checkbox label="4" :disabled="secondDisabled"><label v-html="'其&nbsp;&nbsp;&nbsp;&nbsp;他'"></label>
                        </el-checkbox>
                        <el-input :disabled="secondDisabled" v-model.trim="formData.placement[4].name" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>ml</span>
                        <el-input :disabled="secondDisabled" v-model.trim="formData.placement[4].data" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>ml</span>
                        <el-input :disabled="secondDisabled" v-model.trim="formData.placement[4].colour" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input><span>色</span>
                    </div>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="8.皮肤情况：">
                <el-checkbox-group :disabled="secondDisabled" v-model="formData.skinPostoperative">
                    <el-checkbox label="1">正常</el-checkbox>
                    <el-checkbox label="2">其他</el-checkbox>
                </el-checkbox-group>
                <el-input :disabled="secondDisabled" v-model.trim="formData.skinPostoperativeOther" style="width:60%;" placeholder="请输入其他"></el-input>
            </el-form-item>

            <el-form-item label="9.带药、物：">
                <div>
                    <el-input :disabled="secondDisabled" v-model.trim="formData.drugPostoperative" style="width:60%;" placeholder="请输入药品"></el-input>
                </div>
                <div>
                    <el-input :disabled="secondDisabled" v-model.trim="formData.articlePostoperative" style="width:60%;" placeholder="请输入物品"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="交接护士签名">
                <el-select clearable :disabled="secondDisabled" @focus="focus" default-first-option filterable :filter-method="empMatch" v-model="formData.postoperativeNurseNo" @input="testSX">
                    <el-option v-for="(item) in newLists" :key="item.id" :label="item.userName" :value="item.id">
                    </el-option>
                </el-select>
                <el-button :disabled="secondButtonDisabled" size="small" type="primary" class="sureButton" @click="secondHand()">术后情况交接</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters(['nurseNoList',]),
    },
    props: ['formData', 'secondDisabled', 'secondButtonDisabled'],
    data() {
        return {
            newLists: [],
        }
    },
    watch: {
        $route(to, from) {
            // if (this.activatedFlag) {
            //     // this.query(this.filters.pagination.page);
            // }
            this.focus()
            this.query()

        },
    },
    created() {
        this.focus()
        this.query()
    },
    methods: {
        query() {
            this.passData = this.$route.params
        },
        testSX() {
            this.$forceUpdate()
        },
        focus() {
            setTimeout(() => {
                this.newLists = this.$store.getters.nurseNoList;
            }, 100);
        },
        empMatch(val) {
            this.newList3 = _g.paramMatch(this.nurseNoList, this.newList3, val, 'userName')
        },
        secondHand() {
            if (Lockr.get("skinEmpId") == this.formData.postoperativeNurseNo) {// id相同是要确认交接
                if (this.formData.auditType == 3) {
                    // 如果是1 术前审核已提交 对接第二模块术后情况
                    this.$parent.thirdMethod()
                    this.formData.auditType = 4
                } else if (this.formData.auditType == 0 || this.formData.auditType == 2) {
                    _g.toast('error', '术后情况还未确认交接！！！')
                } else {
                    _g.toast('error', '术后情况已经完成交接！！！')
                }
            } else if (Lockr.get("skinEmpId") != this.formData.postoperativeNurseNo) {// id不同是要提出交接
                // console.log(this.formData);


                if (Lockr.get("skinEmpId") == this.formData.preoperativeNurseNo) {//
                    if (!this.formData.postoperativeNurseNo || this.formData.postoperativeNurseNo == '') {
                        _g.toast('error', '请选择交接护士！！！')
                        return;
                    } else {
                        this.formData.generalPreparation = this.formData.generalPreparation.toString()
                        this.formData.bowelPreparation = this.formData.bowelPreparation.toString()
                        this.formData.catheterization = this.formData.catheterization.toString()
                        this.formData.skinPreoperative = this.formData.skinPreoperative.toString()
                        this.formData.positionPreoperative = this.formData.positionPreoperative.toString()
                        this.formData.anesthesiaMode = this.formData.anesthesiaMode.toString()
                        this.formData.awarenessState = this.formData.awarenessState.toString()
                        this.formData.decubitusPosition = this.formData.decubitusPosition.toString()
                        this.formData.skinPostoperative = this.formData.skinPostoperative.toString()
                        this.formData.psychologicalNursing = this.formData.psychologicalNursing.toString()
                        this.formData.diet = this.formData.diet.toString()
                        this.formData.position = this.formData.position.toString()
                        this.formData.incision = this.formData.incision.toString()
                        this.formData.conduit = this.formData.conduit.toString()
                        this.formData.propagandaEducation = this.formData.propagandaEducation.toString()
                        this.formData.createBy = Lockr.get('skinEmpId');
                        this.formData.auditType = 3
                        this.formData.leaveObserve = Lockr.get('leaveObserve');
                        this.nurseNoList.forEach(item => {
                            if (item.id == this.formData.postoperativeNurseNo) {
                                this.formData.postoperativeNurseName = item.userName
                            }
                        });
                        if (this.formData.code == 0) {
                            this.formData.leaveObserveId = this.passData.id;
                            api.requestQuiet("/leaveObserve/createHandoverRecord", this.formData, (res) => {
                                if (res.result == true) {
                                    _g.toast("success", '添加成功');
                                    router.push({ path: '/observation/observation', query: { code: 0 }, })
                                    //  router.push({ name: 'observation', params: data })
                                    // this.$router.go(0);
                                } else {
                                    _g.toast("error", res.errMsg);
                                }
                            }, (err) => { });
                        } else if (this.formData.code == 1) {
                            this.formData.leaveObserveId = this.formData.leaveObserveId;
                            api.requestQuiet("/leaveObserve/updateHandoverRecord", this.formData, (res) => {
                                if (res.result == true) {
                                    _g.toast("success", '修改成功');
                                    router.push({ path: '/observation/observation', query: { code: 0 } })
                                    // router.push('/observation/observation')
                                    // this.$router.go(0);
                                } else {
                                    _g.toast("error", res.errMsg);
                                }
                            }, (err) => { });
                        }
                    }
                } else if (Lockr.get("skinEmpId") != this.formData.preoperativeNurseNo) {//待确认
                    if (this.formData.auditType == 2) {
                        _g.toast('error', '术后情况还未提交交接！！！')
                    }
                }

            }


        }
    },
}
</script>
<style scoped>
.second {
  border: 1px solid #eee;
  border-radius: 4px;
  margin-top: 10px;
  background: #eee;
}
.people {
  margin-right: 20px;
}
.second >>> .el-form-item {
  margin-bottom: 0px !important;
}
</style>


